import { callApi } from "repoV2/utils/common/api/callApi";
import {
    IInitiateBookingApiResponse,
    IInitiateBookingPayload,
} from "repoV2/features/Payments/Payments.interface";
import { CALL_API_METHODS } from "repoV2/constants/apis";
import { payment_api } from "../Payments.constants";

/**
 * This function calls the initiate payment api and handles the
 * login, check availability and update availability in a single flow
 * @param object { paymentPayload } Payload to intiiate payment
 * @returns A promise containing api response with gateway details to make payment
 */
export const callInitiateBookingApi = ({
    paymentPayload,
}: {
    paymentPayload: IInitiateBookingPayload;
}): Promise<{ data: IInitiateBookingApiResponse }> =>
    callApi({
        url: payment_api.initiate_payment,
        method: CALL_API_METHODS.POST,
        data: paymentPayload,
        extraOptions: {
            appendExlyBackendHeaders: true,
        },
    });
